import { Values, Product } from './types';
import { onlyNumbers } from '~constants/regularExpressions';
import moment from 'moment';
import { parseCurrencyStringToNumber } from '~utils/formatters';
import { cnpj } from '@frete.com/toolkit-sdk';
export { formatCitiesOptions } from '~utils/formatters';

export const formatCnpjInspectResponse = (response) => {
  return {
    companyName: response?.data?.company_name || '',
    establishmentDate: response?.data?.establishment_date
      ? moment.utc(response?.data?.establishment_date).format('DD/MM/YYYY')
      : '',
    neighborhood: response?.data?.neighborhood || '',
    zipCode: response?.data?.zip_code || '',
    state: response?.data?.state,
    city: response?.data?.city || '',
    number: response?.data?.number || '',
    complement: response?.data?.complement || '',
    tradingName: response?.data?.trading_name || '',
    cnpj: response?.cnpj || '',
    revenue: response?.data?.revenue ? String(response?.data?.revenue) : '',
    street: response?.data?.street || '',
    terms: false,
    legalNature: response?.data?.legal_nature,
  };
};

export const formatPayload = (
  formValues: Values,
  companyName: string,
  establishmentDate: string,
  legalNature: number,
  product: Product,
  activityCode: string,
  ncaLinkId?: string
) => {
  return {
    ...(ncaLinkId ? { nca_link_id: ncaLinkId } : {}),
    neighborhood: formValues.neighborhood,
    zip_code: formValues.zipCode.replace(onlyNumbers, ''),
    state: formValues.state,
    city: formValues.city,
    number: formValues.number,
    complement: formValues.complement,
    trading_name: formValues.tradingName,
    cnpj: cnpj.normalize(formValues.cnpj),
    revenue: parseCurrencyStringToNumber(formValues.revenue),
    street: formValues.street,
    company_name: companyName,
    establishment_date: moment(establishmentDate, 'DD/MM/YYYY').format(
      'YYYY-MM-DD'
    ),
    product: product || 'account',
    legal_nature: legalNature,
    activity_code: activityCode,
  };
};
